module.exports = __webpack_public_path__ + "static/img/fullscreen-image_easy-to-get-started_600.6c28f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_easy-to-get-started_600.png
// module id = aeq3
// module chunks = 0